import React from 'react';
import { Divider, Switch, Tooltip } from 'antd';
import {
  DeleteOutlined,
  CopyOutlined,
} from '@ant-design/icons';

import Paragraphe from '../questionTypes/Paragraphe';
import ChoixMultiples from '../questionTypes/ChoixMultiples';
import Checkboxes from '../questionTypes/Checkboxes';
import ListeDeroulante from '../questionTypes/ListeDeroulante';
import UploadFichier from '../questionTypes/UploadFichier';
import InputDate from '../questionTypes/InputDate';
import InputHeure from '../questionTypes/InputHeure';
import Emails from '../questionTypes/Emails';
import Nombres from '../questionTypes/Nombres';
import ReponseCourte from '../questionTypes/ReponseCourte';

const QuestionItem = ({ question,onDelete,onChange,value, onDuplicate, onToggleRequired, isCollapsed , onChangeOptions}) => {
  const { id, label, type, options = [], required } = question;

 const renderInputByType = () => {
  switch (type) {
    case 'text':
      return <ReponseCourte disabled value={value} onChange={onChange}/>;
    case 'textarea':
      return <Paragraphe disabled value={value} onChange={onChange}/>
    case 'radio':
      return <ChoixMultiples options={options} editable={!isCollapsed} onChange={onChangeOptions} disabled />;
    case 'checkbox':
      return <Checkboxes options={options} editable={!isCollapsed} onChange={onChangeOptions} disabled />;
    case 'select':
      return <ListeDeroulante options={options} editable={!isCollapsed} onChange={onChangeOptions} disabled />;
    case 'file':
      return <UploadFichier disabled />;
    case 'date':
      return <InputDate disabled />;
    case 'time':
      return <InputHeure disabled  />;
    case 'email':
      return <Emails disabled  />;
    case 'number':
      return <Nombres disabled />;
    default:
      return null;
  }
};

//   if (isCollapsed) {
//   return (
//     <div>
//       <div>{renderInputByType()}</div>
//     </div>
//   );
// }




  return (
    <div>
      
      <div style={{ marginTop: 8 }}>{renderInputByType()}</div>

      {required && (
        <p style={{ color: 'red', fontStyle: 'italic', marginTop: 8 }}>
          * Cette question est obligatoire
        </p>
      )}

      

      {!isCollapsed && (<>
        <Divider style={{ marginTop: '8%' }} />
        <div style={{ display: 'flex', gap: '24px', marginTop: 16, float: 'right' }}>
        <Tooltip title="Dupliquer">
          <CopyOutlined
            style={{ fontSize: 20, cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              onDuplicate(id);
            }}
          />
        </Tooltip>

        <Tooltip title="Supprimer">
          <DeleteOutlined
            style={{ fontSize: 20, cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(id);
            }}
          />
        </Tooltip>

        <Tooltip title="Rendre obligatoire">
          <span
            onClick={(e) => {
              e.stopPropagation();
              onToggleRequired(id);
            }}
            style={{ cursor: 'pointer' }}
          >
            <span style={{ marginRight: '3px' }}>Obligatoire</span>
            <Switch checked={required} />
          </span>
        </Tooltip>
      </div></>)}
    </div>
  );
};

export default QuestionItem;
